<template>
  <div class="home data-panel-home">
    <Header title="绑定账号"></Header>
    <!-- <div
      class="wechat-home"
      v-if="emails && emails.length"
    >
      <div class="email-item">
        已绑定账号：
      </div>
      <div
        v-for="item in emails"
        class="email-item"
      >
        {{item}}
      </div>
    </div> -->
    <!-- <div
      v-else
      class="wechat-home"
    >
      <div>还没有绑定账号</div>
    </div> -->
    <div class="bindEmail bind-email-wrap">
      <h4>账号绑定</h4>
      <el-input
        class="wechat-bind-email"
        v-model="email"
        placeholder="博纳云邮箱"
      ></el-input>
      <el-input
        v-model="password"
        type="password"
        placeholder="账户密码"
      ></el-input>
      <div
        class="button wechat-bind-email"
        @click="bindEmail"
      >确定</div>
      <!-- <div class="search-emaillist"><a href="https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx95ccc89810c1da7f&redirect_uri=https%3a%2f%2fconsole.bonuscloud.work%2fwechat%2funbind&response_type=code&scope=snsapi_base&state=123&connect_redirect=1#wechat_redirect">点击查看账号列表</a></div> -->
      <div class="tips" style="margin-top: 20px;">每个微信可关联绑定多个博纳云账号</div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState, mapActions, mapMutations } from "vuex";
import Header from "@/WechatComponents/Header.vue";
const WECHAT_HOST = "https://open.weixin.qq.com/connect/oauth2/authorize";
import { getCookie } from "@/utils/utils";
import { Message } from "element-ui";

export default {
  name: "home",
  components: {
    Header
  },
  data() {
    return {
      email: "",
      password: ""
    };
  },
  computed: mapState({
    openid: state => state.wechat.openid,
    emails: state => state.wechat.emails
  }),
  created() {
    try {
      let that = this;

      console.log(this.$route.query);
      
      let openid = getCookie("openid") || this.$route.query.openid;

      let redirect_url =
        this.$route.query.redirect_url ||
        "https%3a%2f%2fconsole.bonuscloud.work%2fwechat";
      let appid = this.$route.query.appid || "wx95ccc89810c1da7f";
      let code = this.$route.query.code;
      // alert("search", window.location.search);
      // alert("href", window.location.href);

      console.log(openid, code);

      if (openid || code) {
        this.openId = openid;

        this.getWechatInfo({ openid, code });
      } else {
        // window.location.href = "http://127.0.0.1:8080/wechat?code=051jslGa1e89uD0UAlGa1x2l3B4jslGS&state=123"
        window.location.href = `${WECHAT_HOST}?appid=${appid}&redirect_uri=${redirect_url}&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`;
      }
    } catch (error) {
      alert(error);
    }
  },
  methods: {
    ...mapActions(["getWechatInfo", "bindWechatEmail"]),
    bindEmail() {
      let that = this;
      let { password, email, openid} = this;

      if (!password || !email) {
        return Message({
          message: "请填写用户名和邮箱",
          type: "error"
        });
      }

      this.bindWechatEmail({
        openid,
        // openid: 'o2FSQwHk24gxCU4fAGhqtkUNRPYw',
        email,
        password,
        code: this.$route.query.code
      }).then(res => {
        if (res.code === 200) {
          
          Message({
            type: "success",
            message: res.message
          });

          that.getWechatInfo({ openid });
        } else {
          Message({
            type: "error",
            message: res.message || "绑定失败，请重试"
          });
        }
      });
    }
  }
};
</script>

<style lang="stylus">
.data-panel-home.home {
  height: auto !important;
}

.wechat-home {
  background: #fff;
  text-align: center;
  padding: 20px;
}

.bind-email-wrap {
  padding: 30px 20px;
  background: #fff;
  text-align: center;
}

.wechat-bind-email {
  margin: 20px 0;
}

.wechat-bind-email {
  margin-top: 20px;
}

.wechat-page{
  background: #fff;
  height: 100%!important;
  .home{
  height: 100%!important;
  }
}

.wechat-page .tips{
  margin: 60px 0 ;
  font-size: 12px;
  text-align: center;
  justify-content: center;
}
.search-emaillist{
  font-size:14px;
  margin-top:40px;
}
.search-emaillist a{
  color:#2c3e50;
}

</style>

